import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    base: "border-b border-border-light",
    trigger: "flex items-center justify-between w-full py-4 lg:py-6 cursor-pointer group/facet-trigger text-left gap-4 px-3 text-heading-2xs lg:text-heading-sm",
    content: "pb-6 px-3 text-body-sm bg-background-surface text-balance -mt-2 lg:-mt-4",
    icon: "w-6 h-6",
    item: "border-b border-gray-200 last:border-b-0",
    header: "flex justify-between items-center text-heading-xl",
    headerWrapper: "flex items-center gap-2 pb-3",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:-rotate-180 group-data-[state=closed]:rotate-0 transition-transform transform w-auto w-3.5 h-3.5 mr-6 flex",
    iconClose: "hidden"
  },
  variants: {}
}), r = e({
  slots: {
    base: "flex flex-col px-4 pt-4 pb-20 gap-2 lg:h-full lg:p-6 lg:m-0 lg:min-w-[400px] lg:w-[20vw] bg-white overflow-scroll h-[80dvh] max-h-[80dvh] lg:max-h-none",
    filterHeader: "flex justify-between border-b border-gray-200 pb-6 pt-2",
    filterHeaderTitle: "text-heading-xs",
    activeFilters: "px-4 lg:px-6 flex flex-col gap-2",
    activeFiltersList: "flex gap-2 flex-wrap",
    filterOptions: "overflow-hidden transition-all duration-300 flex flex-col",
    filterOptionIndicator: "w-4 h-4 mr-1 data-[is-selected=true]:bg-black border border-black rounded-sm",
    filterOption: "py-2 flex items-center gap-3 [&>div]:hover:bg-black",
    filterSubheading: "text-sm font-medium text-gray-700 py-2 px-1 border-b border-gray-100",
    filterGroupedContainer: "flex flex-col gap-4",
    filterGroupedSection: "flex flex-col gap-2",
    filterGroupedGrid: "flex flex-wrap gap-2",
    filterGroupedButton: "w-14 h-14 flex items-center justify-center rounded-full border border-gray-300 text-sm cursor-pointer hover:border-gray-500 data-[selected=true]:bg-black data-[selected=true]:text-white data-[selected=true]:border-black",
    filterGroupNote: "text-xs italic text-gray-500 py-1 px-2 bg-gray-50 rounded mb-2",
    bottomRow: "flex justify-between items-center gap-2 absolute left-0 right-0 bottom-0 z-10 bg-white p-4 border-t border-gray-200 border-solid",
    filterOptionHierarchicalList: "pl-3 flex flex-col gap-2 py-1",
    filterOptionHierarchicalItem: "flex items-center justify-between",
    filterOptionHierarchicalItemButton: "ml-2 flex items-center gap-3 shrink-0 w-6 h-6 flex items-center justify-center rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
  },
  variants: {}
}), o = {
  main: r,
  accordion: t.clone()
};
export {
  r as filterGlasgow,
  o as filterGlasgowBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
